import React from 'react';

import { Chip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import action_library_messages from 'messages/action_library_messages';

import useStyles from './StepsNavigation.styles';

type Props = {
  steps: ActionTemplate['steps'];
};

const StepsNavigation: React.FC<Props> = ({ steps }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!steps || steps.length === 0) return null;

  const sortedSteps = [...steps].sort((a, b) => (a.order || 0) - (b.order || 0));

  const handleStepClick = (stepId: number) => {
    const element = document.getElementById(`step-${stepId}`);
    if (element) {
      const offset = 100; // Offset to account for sticky navigation
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const titleTruncated = (title: string) => {
    if (title.length > 15) {
      return `${title.substring(0, 15)}...`;
    }
    return title;
  };

  return (
    <div className={styles.navigationContainer}>
      <div className={styles.stepsList}>
        {t(action_library_messages.detail.list_of_steps)}:
        {sortedSteps.map((step, index) => (
          <Chip
            key={step.id}
            className={styles.stepChip}
            clickable
            label={`${index + 1}. ${titleTruncated(step.title)}`}
            onClick={() => handleStepClick(step.id)}
            size='small'
            variant='outlined'
          />
        ))}
      </div>
    </div>
  );
};

export default StepsNavigation;
